import { Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';
import { CommonModule, CurrencyPipe } from '@angular/common';

@Component({
standalone: true,
  selector: 'app-avatar',
  templateUrl: './avatar.component.html',
  styleUrls: ['./avatar.component.scss'],
  imports: [CommonModule],
})
export class AvatarComponent {
  /**
   * Defines the text to display.
   * @group Props
   */
  @Input()
  public label: string | undefined;
  /**
   * Defines the icon to display.
   * @group Props
   */
  @Input() icon: string | undefined;
  /**
   * Defines the image to display.
   * @group Props
   */
  @Input() image: string | undefined;
  /**
   * Size of the element.
   * @group Props
   */
  @Input() size: 'normal' | 'large' | 'xlarge' | undefined = 'normal';
  /**
   * Shape of the element.
   * @group Props
   */
  @Input() shape: 'square' | 'circle' | undefined = 'square';
  /**
   * Inline style of the element.
   * @group Props
   */
  @Input() style: { [klass: string]: any } | null | undefined;
  /**
   * Class of the element.
   * @group Props
   */
  @Input() styleClass: string | undefined;
  /**
   * Establishes a string value that labels the component.
   * @group Props
   */
  @Input() ariaLabel: string | undefined;
  /**
   * Establishes relationships between the component and label(s) where its value should be one or more element IDs.
   * @group Props
   */
  @Input() ariaLabelledBy: string | undefined;


  @Input() width: string = '42px';
  @Input() height: string = '42px';
  @Input() fontSize: string = null;

  /**
   * This event is triggered if an error occurs while loading an image file.
   * @param {Event} event - Browser event.
   * @group Emits
   */
  @Output() onImageError: EventEmitter<Event> = new EventEmitter<Event>();
  @Input() showPointer: boolean = false
  @Input() disabled: boolean = false


  imageError(event: Event) {
    this.onImageError.emit(event);
  }

  @HostBinding('class') get hostClass(): any {
    return this.styleClass;
  }

}
